import { z } from "zod";
import { DesignElementBase, DesignElementGroupableRequiredPart } from "./base";
import { PageBlockDataV2 } from "./data";

//
// Element
//

export const PageBlockV2 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape).extend({
  data: PageBlockDataV2,
});

export type PageBlockV2 = z.infer<typeof PageBlockV2>;

//
// Editor Model
//

export const PageBlockEditorModelV2 = z.object({
  id: z.string(),
  type: z.literal("Block"),
  data: PageBlockDataV2,
});

export type PageBlockEditorModelV2 = z.infer<typeof PageBlockEditorModelV2>;
